__turbopack_context__.v({
  "category": "WCE0NG_category",
  "productCard": "WCE0NG_productCard",
  "productRow": "WCE0NG_productRow",
});
